import './AssignmentComments.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

import AssignmentCommentsRow from './AssignmentCommentsRow';

export default class AssignmentComments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: '',
    };
  }

  componentDidUpdate(prevProps) {
    // clear the comment only after it was saved successfully
    if (prevProps.saving && !this.props.saving && !this.props.error) {
      this.setState({ comment: '' });
    }
  }

  addComment = () => {
    const comment = this.state.comment.trim();
    if (!comment || this.props.saving) return;

    this.props.onAddComment(comment);
  };

  render() {
    const comments = this.props.comments.filter(
      (comment) => comment.comment !== '',
    );

    return (
      <div className="assignemnt-comments-component">
        {this.props.canAddComment && (
          <div className="add-comment">
            <div className="add-comment-title">Add comment</div>
            <textarea
              value={this.state.comment}
              onChange={(event) =>
                this.setState({ comment: event.target.value })
              }
              placeholder="Write a comment for this assignment"
            />
            {this.props.error && (
              <div className="errors">{this.props.error}</div>
            )}
            <div className="add-comment-actions">
              <button
                className="btn btn-info"
                disabled={!this.state.comment.trim() || this.props.saving}
                onClick={this.addComment}
              >
                {this.props.saving ? 'Adding...' : 'Add comment'}
              </button>
            </div>
          </div>
        )}
        <Row className="headerRow">
          <Col sm={4}>User</Col>
          <Col sm={4}>Date</Col>
          <Col sm={4}>Comment</Col>
        </Row>
        {comments.length === 0 && (
          <div className="noRecords">No comments yet</div>
        )}
        {comments.map((comment) => (
          <AssignmentCommentsRow key={comment.id} item={comment} />
        ))}
      </div>
    );
  }
}
